import { createSelector } from 'reselect';
import { initialState } from './reducer';

const loaderStateSelector = (state) => state.loader || initialState;

const loaderSelector = () =>
  createSelector(loaderStateSelector, (state) => state.loader);

export { loaderSelector };
